import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class JobSkillRelationApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'job-skill-relation'
  }

}